export default "__VITE_ASSET__YRhpAbAG__"